import { Alpine, AsyncAlpine } from "./main.alpinejs.js";
// Store variables
import "./stores/sectionIdStore.js";
import "./stores/oneTrustStore.js";

AsyncAlpine.init(Alpine);

// Register components we will lazy load
// TODO: Investigate https://async-alpine.dev/docs/usage/#alias
// Possibly we can do this without needing to register them in here but we would need to first compile them via glob in rollup
// Global
AsyncAlpine.data("app", () => import("./x-data/app/index.js"));
AsyncAlpine.data("dateTime", () => import("./x-data/dateTime.js"));
AsyncAlpine.data("formComponent", () => import("./x-data/formComponent/formComponent.js"));
AsyncAlpine.data("geolocation", () => import("./x-data/geolocation/geolocation.js"));
AsyncAlpine.data("listingFilters", () => import("./x-data/list/listingFilters.js"));
AsyncAlpine.data("locator", () => import("./x-data/locator/index.js"));
AsyncAlpine.data("isi", () => import("./x-data/isi/index.js"));
AsyncAlpine.data("modalScripts", () => import("./x-data/modal/modalScripts.js"));
AsyncAlpine.data("quiz", () => import("./x-data/quiz/quiz.js"));
AsyncAlpine.data("skipToMain", () => import("./x-data/skipToMain/skipToMainScript.js"));
AsyncAlpine.data("pageMenuLink", () => import("./x-data/pageMenuLink/pageMenuLink.js"));
AsyncAlpine.data("anchorTab", () => import("./x-data/pageMenuLink/anchorTab.js"));
AsyncAlpine.data("video", () => import("./x-data/video/video.js"));
AsyncAlpine.data("priceSpider", () => import("./x-data/priceSpider/priceSpider.js"));
AsyncAlpine.data("bazaarVoiceWidget", () => import("./x-data/bazaarVoice/bazaarVoiceWidget.js"));
AsyncAlpine.data("scrollToTop", () => import("./x-data/scrollToTop/scrollToTop.js"));
AsyncAlpine.data("nav", () => import("./x-data/nav/nav.js"));
AsyncAlpine.data("form", () => import("./x-data/form/index.js"));
AsyncAlpine.data("productDetailInfo", () => import("./x-data/productDetailInfo/index.js"));
AsyncAlpine.data("whereToBuy", () => import("./x-data/whereToBuy/index.js"));
AsyncAlpine.data("stickyNavHighlight", () => import("./x-data/stickyNavHighlight/stickyNavHighlight.js"));
AsyncAlpine.data("simplifiedRichText", () => import("./x-data/simplifiedRichText/index.js"));
AsyncAlpine.data("editComponent", () => import("./x-data/editComponent/index.js"));
AsyncAlpine.data("references", () => import("./x-data/industrialization/references/index.js"));
AsyncAlpine.data("quicklinks", () => import("./x-data/industrialization/quicklinks/index.js"));
AsyncAlpine.data("storeListing", () => import("./x-data/storeListing/index.js"));
AsyncAlpine.data("legalBanner", () => import("./x-data/legalBanner/index.js"));
